import { useCallback, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import sentry from 'legacy/utils/sentry'

import { type Shipment } from '../../domain/shipment/Shipment'
import { getShipment } from '../../use-cases/getShipment'

export function useShipment() {
  const [shipment, setShipment] = useState<undefined | Shipment>(undefined)
  const [fetchShipmentStatus, setFetchShipmentStatus] = useState(RequestStatus.Initial)

  const isFetchingShipment = fetchShipmentStatus === RequestStatus.Pending

  const fetchShipment = useCallback(async (shipmentId: string, signal: AbortSignal) => {
    setFetchShipmentStatus(RequestStatus.Pending)

    try {
      const shipment = await getShipment(shipmentId, { signal })

      setShipment(shipment)
      setFetchShipmentStatus(RequestStatus.Done)
    } catch (error) {
      if (!signal.aborted) {
        setFetchShipmentStatus(RequestStatus.Error)
        sentry.log(error)

        throw new Error('Could not fetch shipment', { cause: error as Error })
      }
    }
  }, [])

  return {
    shipment,
    isFetchingShipment,
    fetchShipmentStatus,
    fetchShipment,
  }
}
